"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getSnackBarDefaultStyles = void 0;
var utils = _interopRequireWildcard(require("../../components/SnackBar/SnackBar"));
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function (e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (const t in e) "default" !== t && {}.hasOwnProperty.call(e, t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, t)) && (i.get || i.set) ? o(f, t, i) : f[t] = e[t]); return f; })(e, t); }
const getSnackBarDefaultStyles = _ref => {
  let {
    style,
    borderColor,
    backgroundColor,
    textColor,
    iconColor
  } = _ref;
  switch (style) {
    case 'default':
    case 'thumbnail':
      return {
        borderColor: 'border-notification',
        backgroundColor: 'background-notification',
        textColor: 'default',
        iconColor: 'default'
      };
    case 'error':
      return {
        borderColor: 'border-error',
        backgroundColor: 'background-error',
        textColor: 'default',
        iconColor: 'default'
      };
    case 'unstyled':
    default:
      return {
        borderColor: borderColor ?? utils.defaultProps.borderColor,
        backgroundColor: backgroundColor ?? utils.defaultProps.backgroundColor,
        textColor: textColor ?? utils.defaultProps.textColor,
        iconColor: iconColor ?? utils.defaultProps.iconColor
      };
  }
};
exports.getSnackBarDefaultStyles = getSnackBarDefaultStyles;